<template>
    <div class="eazy-toast-box animated">
        <slot name="title"></slot>
        <slot></slot>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.eazy-toast-box {
    width: 400px;
    background-color: #ffffff;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
    border-radius: 4px;
    position: fixed;
    z-index: 999;
    top: 280px;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #000;
    font-size: 16px;
    padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/eazytoast.vue